// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import Close from "@werner/XDL/Icons/Close";
import { buttonTransparent } from "@werner/XDL/PreStyle/button";
import { xBaseTheme } from "@werner/XDL/types";
import { color, ellipsis, styledScrollbar, xScreen } from "@werner/XDL/Utilities";
import { css } from "styled-components";

export default {
    sizeVariants: { small: 400, medium: 700, large: 1136 },
    defaultProps: {
        mergeCss: true,
        cssOverrides: {
            modalBody: css`
                overflow: hidden;
                border: none;
                border-radius: 0;
                background: ${color("common.white")};
                &&&& {
                    box-shadow: 0 0 15px 0 ${color("primary", 0.05)};
                }
                overflow: unset;

                //Delete this media query for a full-screen modal on mobile
                ${xScreen("lte", "md")} {
                    max-width: 90%;
                    height: auto;
                    max-height: calc(100% - 35px);
                    margin: 15px;
                }
            `,
            headlineTypography: css``,
            titleButton: css`
                &&&& {
                    ${buttonTransparent}
                    padding: 0;
                    position: absolute;
                    right: 10px;
                    top: 14px;
                    &:focus {
                        outline: none;
                    }

                    & > ${IconWrapper} {
                        position: unset;
                        top: 0;
                        color: ${color("common.ui3")};
                    }
                    &:hover:not(:disabled) {
                        ${buttonTransparent}
                        background-color: ${color("common.white")};
                        & > ${IconWrapper} {
                            color: ${color("text.main")};
                        }
                    }
                }
            `,
            modalTitle: css`
                &&& {
                    border-bottom: none;
                    border-top: 4px solid ${color("primary")};
                    padding: 16px 30px 10px 30px;

                    & > h3 {
                        padding-right: 0;
                        margin-bottom: 0;
                        margin-top: 16px;
                    }
                }
            `,
            modalContent: css`
                &&& {
                    padding: 16px 30px 16px 30px;
                }

                flex: 1;
                display: flex;
                flex-direction: column;

                }
            `,
        },
        sizeVariant: "medium",
        headlineTypographyProps: {
            variant: "h3",
            css: css`
                margin-bottom: 0;
                margin-top: 16px;
            `,
        },
        closeButtonProps: {
            buttonType: "solid",
            sizeVariant: "small",
            shape: "pill",
            variant: "primary",
            color: "common.white",
            size: 42,
        },
        closeButtonIconProps: {
            src: Close,
            size: 16,
            color: "common.ui3",
        },
    },
} as xBaseTheme["modal"];
